module.exports = __webpack_public_path__ + "static/media/information.ba6fbce8.svg";